import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Button from "../atoms/common/Button"
import classes from "./ConbookButton.module.scss"

// FIXME ちょっと気持ち悪いけど暫定対応
const ConbookButton: React.FC = () => {
  const { i18n } = useTranslation()
  let buttonName
  switch (i18n.language) {
    case "ja":
      buttonName = "JMoF 2023コンブック"
      break
    default:
      buttonName = "JMoF 2023 Conbook"
  }

  const to = "/pdf/JMF23_conbook_web.pdf"

  return (
    <>
      <div className={classes.ConbookButton}>
        <Button name={buttonName} to={to} noUppercase />
      </div>
    </>
  )
}

export default ConbookButton
